import { type FC, useEffect } from "react";
import { useLocation } from "react-router";
import { DrawerComponent } from "../../assets/ts/components";
import type { WithChildren } from "../../helpers";
import { useLayout } from "../core";

const Content: FC<WithChildren> = ({ children }) => {
	const { classes } = useLayout();
	const _location = useLocation();
	useEffect(() => {
		DrawerComponent.hideAll();
	}, []);

	return (
		<div
			id="kt_content_container"
			// className={clsx(classes.contentContainer.join(' '))}
			className="w-100 mx-5"
		>
			{children}
		</div>
	);
};

export { Content };
